import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import rubikFontBase64 from "~/assets/rubikFontBase64.js";
import logoBase64 from "~/assets/logoBase64";

import { IJournalTicketData } from "~/types/journal";

export const createTicketPdf = (appointment: IJournalTicketData) => {
  const doc = new jsPDF();

  doc.addFileToVFS("Rubik-Regular.ttf", rubikFontBase64);
  doc.addFont("Rubik-Regular.ttf", "Rubik-Regular", "normal");
  doc.setFont("Rubik-Regular");

  autoTable(doc, {
    // theme: "grid",
    styles: {
      font: "Rubik-Regular",
      cellPadding: { left: 5, right: 5, top: 2, bottom: 2 },
    },
    tableWidth: 105,
    margin: { left: 55, top: 26 },
    didDrawPage: function (data) {
      doc.addImage(
        logoBase64,
        "PNG",
        data.settings.margin.left + 21,
        9,
        60,
        12
      );
    },
    head: [
      [
        {
          content: "Талон на прием к врачу",
          colSpan: 2,
          styles: {
            valign: "middle",
            halign: "center",
            fillColor: "#fa5773",
            fontSize: 11,
            cellPadding: { top: 4, bottom: 4, left: 2, right: 2 },
          },
        },
      ],
    ],
    body: [
      ["ФИО", appointment.patientName],
      ["Адрес", appointment.address],
      ["ЛПУ", appointment.hospitalName],
      ["Специальность", appointment.specialtyName],
      ["Врач", appointment.doctorName],
      ["Дата приёма", appointment.dt],
      ["Время приёма", appointment.value],
    ],
  });

  console.log(appointment.patientName);

  doc.save(`${appointment.idTicket}.pdf`);
};
